export default __webpack_public_path__ + "static/media/26.d560afc9.jpeg";